export enum DepartmentRolesActionTypesEnum {
  DEPARTMENT_ROLES_ACTION_REQUEST = 'DEPARTMENT_ROLES_ACTION_REQUEST',
  DEPARTMENT_ROLES_ACTION_RESPONSE = 'DEPARTMENT_ROLES_ACTION_RESPONSE',
  DEPARTMENT_ROLES_ACTION_ERROR = 'DEPARTMENT_ROLES_ACTION_ERROR',
}
